export const getMarkerStyle = (marker, mode, opts = undefined) => {
    const { useShadow: _1 = true, useStroke = true } = opts !== null && opts !== void 0 ? opts : {};
    const { size = 1 } = marker;
    switch (mode) {
        case 'fill':
            return {
                primary: {
                    stroke: 'none',
                    fill: marker.color,
                },
                secondary: useStroke
                    ? {
                        fill: 'white',
                        stroke: 'white',
                        strokeOpacity: '0.95',
                        strokeWidth: size.toFixed(0),
                    }
                    : { fill: 'none', stroke: 'none' },
            };
        default:
            return {
                primary: {
                    fill: 'none',
                    stroke: marker.color,
                    strokeWidth: size.toFixed(0),
                },
                secondary: useStroke
                    ? {
                        fill: 'none',
                        stroke: 'white',
                        strokeOpacity: '0.95',
                        strokeWidth: (size * 2).toFixed(0),
                    }
                    : { fill: 'none', stroke: 'none' },
            };
    }
};
